<template>
  <footer id="toast_footer">
    <div class="sitemap_wrap" :style="footerStyle" v-if="showSiteMap">
      <div class="inner">
        <router-link-ex :to="countryPath" :domain="getDomain('homepage')" class="logo_toast">
          <img :src="siteMapLogo" alt="NHN Cloud" :class="siteMapLogoClass">
        </router-link-ex>
        <ul class="lst_sns">
          <li class="item_sns" v-for="(sns, i) in footer.snsList" :key="i">
            <a :href="sns.link" class="link_sns" :class="sns.class" target="_blank">{{ sns.text }}</a>
          </li>
        </ul>
        <gnb-footer-site-map />
      </div>
    </div>
    <div class="nhn_footer" :style="footerStyle">
      <div class="inner">
        <em class="logo_nhn">
          <a :href="footer.logoUrl" target="_blank" class="logo_link">
            <img :src="footer.logoImg" alt="NHN JAPAN">
          </a>
        </em>
        <p class="notice_txt is_m_show" v-html="footer.exemptionNotice"></p>
        <ul class="lst_company_link">
          <li class="item_link" v-for="(link, i) in footer.links" :key="i">
            <a v-if="link.isPopup" href="javascript:;" target="_blank" class="link_txt" v-html="link.text" @click.prevent="openPopup(link.url, 665, 720, 'privacy-policy')"></a>
            <a v-else :href="link.url" target="_blank" class="link_txt" v-html="link.text"></a>
          </li>
        </ul>

        <div class="family_site_wrap" :class="{ 'is_active': familySite.active }" v-click-outside="hideFamilySite">
          <button class="btn_family_site" @click="toggleFamilySite">
            <span class="btn_txt">Family site</span>
          </button>
          <ul class="lst_family_site" @click="hideFamilySite">
            <li class="site_item" v-for="(site, i) in footer.familySites" :key="i">
              <a :href="site.link" target="_blank" class="link_txt">{{ site.text }}</a>
            </li>
          </ul>
        </div>

        <p class="notice_txt is_pc_show" v-html="footer.exemptionNotice"></p>

        <ul class="lst_company_info">
          <li class="info_item" v-for="(companyInfo, i) in footer.companyInfo" v-html="companyInfo.text" :key="i"></li>
        </ul>
        <p class="copyright_txt">{{ footer.copyright }}</p>

      </div>
    </div>
  </footer>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

import { namespace, types, commonStore } from '../../store/modules/common-store'
import { types as sessionTypes, namespace as sessionNamespace } from '../../store/modules/session-store'

import GnbFooterSiteMap from './GnbFooterSiteMap'

export default {
  props: {
    width: {
      type: String,
      default: null
    },
    betweenMargin: {
      type: String,
      default: null
    },
    showSiteMap: {
      type: Boolean,
      default: true
    },
    customerCenter: {
      type: Object,
      default: () => {
        return {
          tel: '1588-7967',
          email: service.email,
          isDefault: true // default로 쓰일 경우를 분기하기 위해서 사용
        }
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
    this.setUserLocale()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      familySite: {
        active: false
      },
      siteMapLogo: (() => {
        const imgName = `${envs.logo.white}`
        if (mode === 'homepage') {
          return require(`../../assets/img/${imgName}`)
        }
        return `${domain.cdn}/resources/img/${imgName}`
      })(),
      siteMapLogoClass: `${envs.logo.class}`
    }
  },
  computed: {
    ...mapState(namespace, ['isMobile']),
    ...mapState(sessionNamespace, ['mode', 'userLocale']),
    isDefaultCustomerCenter() {
      return !!this.customerCenter.isDefault && this.customerCenter.isDefault === true
    },
    footerStyle() {
      return { width: this.width, 'margin-left': this.betweenMargin, 'margin-right': this.betweenMargin }
    },
    corporationUrl() {
      if (this.isJp) {
        return 'https://www.nhn-japan.com/'
      }

      const lang = this.userLocale.lang
      if (lang === 'ko') {
        return `${envs.common.footer.companyLank}`
      }

      const mappedLang = {'en': 'en', 'ja':'ja', 'zh':'en'}
      return `${envs.common.footer.companyLank}?lang=${mappedLang[lang]}`
    },
    footer() {
      const homepageBase = this.canUseRoute ? '' : this.getDomain('homepage')
      const logoImgFileName = this.isJp ? 'logo_footer_nhn_jp.png' : 'logo_footer_nhn_cloud.png'
      const logoImg = this.canUseRoute ? require(`../../assets/img/${logoImgFileName}`) : `${domain.cdn}/resources/img/${logoImgFileName}`

      const commonLinks = [
        {
          text: this.$t('gnb.introduce'),
          url: this.corporationUrl,
          isPopup: false
        },
        {
          text: this.$t('gnb.terms'),
          url: `${homepageBase}${this.countryPath}/terms/terms-service`,
          isPopup: true
        },
        {
          text: this.$t('gnb.sla'),
          url: `${homepageBase}${this.countryPath}/terms/terms-sla`,
          isPopup: true
        },
        {
          text: `<em class="point_txt">${this.$t('gnb.privacy')}</em>`,
          url: `${homepageBase}${this.countryPath}/terms/privacy-policy`,
          isPopup: true
        }
      ]
      return this.isJp
        ? {
            snsList: [
              {
                link: 'https://twitter.com/nhncloudjp',
                class: 'ico_twitter',
                text: this.$t('gnb.sns.twitter')
              },
              {
                link: 'https://www.facebook.com/nhncloudjp/',
                class: 'ico_facebook',
                text: this.$t('gnb.sns.facebook')
              }
            ],
            logoUrl: this.corporationUrl,
            logoImg: logoImg,
            links: commonLinks.concat([
              {
                text: `${this.$t('gnb.jp.commercialLaw')}`,
                url: `${homepageBase}${this.countryPath}/terms/commercial-law`,
                isPopup: true
              },
              {
                text: `${this.$t('gnb.jp.supportPolicy')}`,
                url: `${homepageBase}${this.countryPath}/terms/support-policy`,
                isPopup: true
              }
            ]),
            familySites: [
              {
                link: `https://www.toast.com/jp`,
                text: 'NHN Cloud'
              },
              {
                link: 'https://cam.toast.com/jp/',
                text: 'TOAST CAM'
              },
              {
                link: 'https://dooray.com',
                text: 'Dooray!'
              }
            ],
            companyInfo: [
              {
                text: this.$t('gnb.jp.footer.company-name')
              },
              {
                text: this.$t('gnb.jp.footer.ceo')
              },
              {
                text: this.$t('gnb.jp.footer.address')
              },
              {
                text: `${this.$t('gnb.jp.footer.customer-center')} : ${
                  this.isDefaultCustomerCenter ? this.$t('support.jp.phone') : this.customerCenter.tel
                }`
              },
              {
                text: `${this.$t('common.email')} : <a href="mailto:${this.customerCenter.email}">${this.customerCenter.email}</a>`
              }
            ],
            copyright: this.$t('gnb.jp.footer.copyright'),
            exemptionNotice: this.$t('gnb.jp.footer.exemption-notice-text')
          }
        : {
            snsList: [
              {
                link: 'https://www.facebook.com/nhncloud/',
                class: 'ico_facebook',
                text: this.$t('gnb.sns.facebook')
              },
              {
                link: 'https://www.youtube.com/c/NHNCloud',
                class: 'ico_youtube',
                text: this.$t('gnb.sns.youtube')
              },
              {
                link: 'https://blog.naver.com/nhncloud_official',
                class: 'ico_blog',
                text: this.$t('gnb.sns.blog')
              }
            ],
            logoUrl: this.corporationUrl,
            logoImg: logoImg,
            links: commonLinks,
            familySites: [
              {
                link: `https://www.toast.com/kr`,
                text: 'NHN Cloud'
              },
              {
                link: 'https://gov.toast.com/',
                text: 'NHN Cloud (공공기관용)'
              },
              {
                link: 'http://cam.toast.com',
                text: 'TOAST CAM'
              },
              {
                link: 'http://bizcam.toast.com',
                text: 'TOAST CAM Biz'
              },
              {
                link: 'https://etax.toast.com',
                text: 'Dooray! eTax'
              },
              {
                link: 'https://dooray.com',
                text: 'Dooray!'
              },
              {
                link: 'http://www.payco.com',
                text: 'PAYCO'
              },
              {
                link: 'https://developers.payco.com',
                text: 'PAYCO 개발자센터'
              },
              {
                link: 'http://www.hangame.com',
                text: 'Hangame'
              }
            ],
            companyInfo: [
              {
                text: this.$t('gnb.footer.company-name')
              },
              {
                text: this.$t('gnb.footer.ceo')
              },
              {
                text: this.$t('gnb.footer.address')
              },
              {
                text: `${this.$t('gnb.footer.customer-center')}: ${
                  this.isDefaultCustomerCenter ? this.$t('support.kr.phone') : this.customerCenter.tel
                }`
              },
              {
                text: `${this.$t('common.email')}: <a href="mailto:${this.customerCenter.email}">${this.customerCenter.email}</a>`
              },
              {
                text: this.$t('gnb.footer.business-registration-number')
              },
              {
                text: this.$t('gnb.footer.online-sales-business-registration-number')
              },
              {
                text: `<a href="https://www.ftc.go.kr/bizCommPop.do?key=232&apv_perm_no=2022378021930201507&pageUnit=10&searchCnd=wrkr_no&wrkr_no=4248802352&pageIndex=1"
                target="_blank" class="link_txt">${this.$t('gnb.footer.check-business-information')}</a>`
              }
            ],
            copyright: this.$t('gnb.kr.footer.copyright'),
            exemptionNotice: this.$t('gnb.footer.exemption-notice-text')
          }
    }
  },
  methods: {
    ...mapMutations(namespace, [types.SET_FOOTER_RECT]),
    ...mapMutations(sessionNamespace, [sessionTypes.SET_USER_LOCALE]),
    handleScroll() {
      this.setFooterRect(this.$el.getBoundingClientRect())
    },
    toggleFamilySite() {
      this.familySite.active = !this.familySite.active
    },
    hideFamilySite() {
      this.familySite.active = false
    }
  },
  components: { GnbFooterSiteMap }
}
</script>
